export const adminDemoData = [
    {
        id: 11111,
        role: 'customer',
        firstName: 'Yeasin',
        lastName: 'Arafat',
        fullName: 'Yeasin Arafat',
        organization: 'Bikiran',
        primaryPhone: '01795617763',
        primaryEmail: 'yeasinn2002@gmail.com',
        photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/profile.jpg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 70,
                subscriptionName: 'HRCT - Purchase',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/HRCT.svg'
            },
            {
                id: 71,
                subscriptionName: 'Digital Experience Checkup -ABC',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/DEC-1.svg'
            }
        ],
        demo: true
    },
    {
        id: 22222,
        role: 'customer',
        firstName: 'Noman',
        lastName: 'Gazi',
        fullName: 'Noman Gazi',
        organization: 'Bikiran.com',
        primaryPhone: '01726387662',
        primaryEmail: 'numan.islam61@gmail.com',
        photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/Noman Gazi.jpeg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 80,
                subscriptionName: 'Envision Pulse - ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg'
            },
            {
                id: 75,
                subscriptionName: 'HRCT - modify ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/HRCT.svg'
            },
            {
                id: 81,
                subscriptionName: 'Envision Pulse - ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg'
            }
        ],
        demo: true
    },
    {
        id: 33333,
        role: 'customer',
        firstName: 'Kumar Bishojit',
        lastName: 'Paul',
        fullName: 'Kumar Bishojit Paul',
        organization: 'PPP',
        primaryPhone: '01717416667',
        primaryEmail: 'bishojit@gmail.com',
        photoUrl:
            'https://storage.googleapis.com/miracle-bucket-23/profile_images/WIN_20231207_15_55_12_Pro.jpg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 74,
                subscriptionName: 'Envision NEXT - ABC',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            },
            {
                id: 77,
                subscriptionName: 'Envision NEXT - OK',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            },
            {
                id: 78,
                subscriptionName: 'Envision NEXT - ABC Hospital',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            }
        ],
        demo: true
    }
];

export const adminInfoDemoData = {
    id: 9,
    firstName: 'Fahim',
    lastName: 'Hossain',
    fullName: 'Fahim Hossain',
    organization: 'Bikiran',
    userName: 'fahim@bikiran.com',
    primaryEmail: 'fahim@bikiran.com',
    primaryPhone: '01897705073',
    tfaEnabled: false,
    role: 'admin',
    permissions: [
        {
            key: 'admin.manager',
            title: 'Manager',
            description: 'With this role user can manage other admin, products and settings.',
            status: true
        },
        {
            key: 'admin.customer',
            title: 'Customer',
            description:
                'With this role user can manage customers and can change customers basic information. Can view the subscriptions, invoices, payments & support ticket information of each customers.',
            status: true
        },
        {
            key: 'admin.subscription',
            title: 'Technical',
            description:
                'With this role user can manage subscription information of the customers. Can view the invoices, payments & support ticket information of each customers.',
            status: true
        },
        {
            key: 'admin.finance',
            title: 'Finance',
            description:
                'With this role user can manage invoices and payments of the customers. Can view the support ticket information of each customers.',
            status: true
        },
        {
            key: 'admin.support',
            title: 'Support',
            description:
                'With this role user can manage the support tickets, can reply. Can view the subscriptions, invoices, payments & support ticket information of each customers.',
            status: true
        },
        {
            key: 'admin.report',
            title: 'Reports',
            description: 'With this role user can view all of the reports.',
            status: true
        },
        {
            key: 'admin.logs',
            title: 'Logs',
            description: 'With this role user can view all of the logs.',
            status: true
        },
        {
            key: 'developer',
            title: 'Developer',
            description: 'With this role user can manage the API keys.',
            status: true
        }
    ],
    userInfo: {
        fullName: 'Fahim Hossain',
        email: 'fahim@bikiran.com',
        phone: '01897705073',
        status: 'active'
    },
    authInfo: {
        tfaStatus: false,
        tfaEmail: 'fahim@bikiran.com',
        timeLastLogin: 1707295232,
        lastLoginIp: '192.168.68.102',
        lastLoginDevice:
            'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36'
    },
    addresses: {
        administrative: {
            id: 29,
            userId: 9,
            addressType: 'administrative',
            firstName: 'Fahim',
            lastName: 'Hossain',
            organization: 'Bikiran',
            address: 'Khulna, Bangladesh',
            phone: '+8801795617763',
            email: 'fahimhossain160@gmail.com',
            country: 'BD',
            state: 'Khulna',
            city: 'Khulna',
            zip: '9000',
            status: 'active'
        },
        billing: {
            id: 28,
            userId: 9,
            addressType: 'billing',
            firstName: 'Fahim',
            lastName: 'Hossain',
            organization: 'Bikiran',
            address: 'Khulna, Bangladesh',
            phone: '+8801795617763',
            email: 'fahimhossain160@gmail.com',
            country: 'BD',
            state: 'Khulna',
            city: 'Khulna',
            zip: '9000',
            status: 'active'
        },
        technical: {
            id: 30,
            userId: 9,
            addressType: 'technical',
            firstName: 'Fahim',
            lastName: 'Hossain',
            organization: 'Bikiran ORG',
            address: 'Khulna, Bangladesh',
            phone: '+8801795617763',
            email: 'fahimhossain160@gmail.com',
            country: 'BD',
            state: 'Khulna',
            city: 'Khulna',
            zip: '9000',
            status: 'active'
        }
    },
    address: 'Khulna, Bangladesh, Khulna, Khulna, 9000',
    status: 'active',
    demo: true
};

export default null;
